if (!customElements.get('hero-heimatgut-slideshow')) {
  customElements.define('hero-heimatgut-slideshow', class extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayInterval = null;
      this.isPaused = false;
    }

    connectedCallback() {
      this.wrap = this.querySelector('.hero-heimatgut__slide-wrap');
      this.slides = this.querySelectorAll('.hero-heimatgut__slide');
      this.dots = this.querySelectorAll('.hero-heimatgut__dot');
      this.prevBtn = this.querySelector('.hero-heimatgut__arrow--prev');
      this.nextBtn = this.querySelector('.hero-heimatgut__arrow--next');
      this.speed = parseInt(this.dataset.speed || '2800', 10);

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => { this.goTo(i); this.resetAutoplay(); });
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.prev(); this.resetAutoplay(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.next(); this.resetAutoplay(); });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());

      this.syncHeight();
      this._ro = new ResizeObserver(() => this.syncHeight());
      this.slides.forEach((s) => this._ro.observe(s));

      this.initTouch();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this._ro) this._ro.disconnect();
    }

    syncHeight() {
      if (!this.wrap) return;
      let maxH = 0;
      this.slides.forEach((s) => {
        maxH = Math.max(maxH, s.scrollHeight);
      });
      this.wrap.style.height = maxH + 'px';
    }

    initTouch() {
      let startX = 0;
      this.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        this.pause();
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          diff > 0 ? this.next() : this.prev();
          this.resetAutoplay();
        }
        this.resume();
      }, { passive: true });
    }

    goTo(index) {
      if (index === this.currentIndex) return;
      this.slides[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex].classList.remove('is-active');
      this.currentIndex = index;
      this.slides[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex].classList.add('is-active');
    }

    next() {
      this.goTo((this.currentIndex + 1) % this.slides.length);
    }

    prev() {
      this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length);
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        if (!this.isPaused) this.next();
      }, this.speed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    pause() {
      this.isPaused = true;
    }

    resume() {
      this.isPaused = false;
    }
  });
}
